/* Blog category filter.

   Only used when the merchant defines categories as section blocks. When the
   blog's articles carry tags instead, the tabs are ordinary links to Shopify's
   /tagged/ routes and this file is not loaded at all.

   Every article is rendered up front and simply hidden or shown, so the page
   still lists everything with JavaScript unavailable — the tabs just do
   nothing in that case rather than leaving a blank grid. */
(function () {
  'use strict';

  function init(root) {
    var scope = root || document;

    Array.prototype.forEach.call(scope.querySelectorAll('[data-blog-tabs]'), function (tabBar) {
      if (tabBar.dataset.filterReady === 'true') return;
      tabBar.dataset.filterReady = 'true';

      // The grid, featured slot and no-results line live outside the tab bar,
      // so scope the lookup to the whole section rather than the bar.
      var section = tabBar.closest('.shopify-section') || document;
      var grid = section.querySelector('[data-blog-grid]');
      if (!grid) return;

      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-blog-cats]'));
      var featured = section.querySelector('[data-blog-featured]');
      var noResults = section.querySelector('[data-blog-noresults]');
      var pagination = section.querySelector('.blog-pagination');
      // The sidebar list drives the same filter.
      var sideButtons = Array.prototype.slice.call(section.querySelectorAll('.blog-catrow[data-blog-cat]'));
      var tabs = Array.prototype.slice.call(tabBar.querySelectorAll('[data-blog-cat]'));

      function apply(category) {
        var shown = 0;

        items.forEach(function (item) {
          var cats = (item.getAttribute('data-blog-cats') || '').split(/\s+/);
          var match = category === 'all' || cats.indexOf(category) !== -1;
          item.hidden = !match;
          if (match) shown++;
        });

        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-blog-cat') === category;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        sideButtons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn.getAttribute('data-blog-cat') === category);
        });

        // The featured slot promotes the newest article overall, which stops
        // being true once a category is chosen.
        if (featured) featured.hidden = category !== 'all';

        // Pagination pages the unfiltered list, so it would lie while a
        // category is active.
        if (pagination) pagination.hidden = category !== 'all';

        if (noResults) noResults.hidden = shown !== 0;
      }

      function choose(category) {
        apply(category);
        // Reflect the choice in the URL so a filtered view can be shared and
        // survives a reload, without a round trip to the server.
        try {
          var url = new URL(window.location.href);
          if (category === 'all') {
            url.searchParams.delete('category');
          } else {
            url.searchParams.set('category', category);
          }
          history.replaceState({}, '', url);
        } catch (e) {
          /* URL is unavailable on very old browsers; filtering still works. */
        }
      }

      tabs.concat(sideButtons).forEach(function (control) {
        control.addEventListener('click', function () {
          choose(control.getAttribute('data-blog-cat'));
        });
      });

      // Restore a category from the URL on load.
      var initial = 'all';
      try {
        var fromUrl = new URL(window.location.href).searchParams.get('category');
        if (fromUrl && tabs.some(function (t) { return t.getAttribute('data-blog-cat') === fromUrl; })) {
          initial = fromUrl;
        }
      } catch (e) { /* ignore */ }

      apply(initial);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // The theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
